import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { SearchInput } from '@sorare/core/src/atoms/inputs/SearchInput';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { glossary } from '@sorare/core/src/lib/glossary';

import { BlogResults } from '#src/components/BlogResults/index.tsx';
import { SportTabs } from '#src/components/Tabs/index.tsx';
import { useBlogSearch } from '#src/hooks/useBlogSearch.ts';

const Root = styled(Vertical).attrs({
  gap: 5,
})`
  margin-top: var(--triple-unit);
`;

const SearchWrapper = styled.div`
  max-width: fit-content;
`;

const messages = defineMessages({
  seoTitle: {
    defaultMessage: 'Fantasy Sports Reimagined - Sorare Blog',
  },
  seoDescription: {
    defaultMessage:
      'Experience football, basketball, and baseball like never before. Collect. Play. Win. #OwnYourGame.',
  },
});

export { loader } from '#src/components/BlogResults/index.tsx';

const Home = () => {
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();
  const { searchInputValue, setSearchInputValue, isPending } = useBlogSearch();

  useEffect(() => {
    setPageMetadata(formatMessage(messages.seoTitle), {
      description: formatMessage(messages.seoDescription),
    });
  }, [formatMessage, setPageMetadata]);

  return (
    <Root gap={4}>
      <SportTabs />
      <SearchWrapper>
        <SearchInput
          withIcon
          placeholder={formatMessage(glossary.search)}
          value={searchInputValue || ''}
          onChange={event => setSearchInputValue(event.target.value)}
        />
      </SearchWrapper>
      <Suspense fallback={null}>
        <BlogResults isSearching={!!isPending} />
      </Suspense>
    </Root>
  );
};
export default Home;
